"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabeledRange = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Flex = require("../Flex");

var _Slider = require("../Slider");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** LabeledRange */
var LabeledRange = /*#__PURE__*/function (_React$Component) {
  _inherits(LabeledRange, _React$Component);

  var _super = _createSuper(LabeledRange);

  function LabeledRange() {
    var _this;

    _classCallCheck(this, LabeledRange);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      min: _this.props.defaultValue[0],
      max: _this.props.defaultValue[1]
    });

    _defineProperty(_assertThisInitialized(_this), "updateMinMax", function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          min = _ref2[0],
          max = _ref2[1];

      _this.setState({
        min: min,
        max: max
      });
    });

    return _this;
  }

  _createClass(LabeledRange, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _newProps$defaultValu = _slicedToArray(newProps.defaultValue, 2),
          min = _newProps$defaultValu[0],
          max = _newProps$defaultValu[1];

      this.setState({
        min: min,
        max: max
      });
    }
  }, {
    key: "maxIndicator",
    value: function maxIndicator() {
      return this.props.max === this.state.max ? "+" : "";
    }
  }, {
    key: "toString",
    value: function toString() {
      var _this$state = this.state,
          min = _this$state.min,
          max = _this$state.max;
      var result = "".concat(min, " - ").concat(max).concat(this.maxIndicator());

      if (this.props.unit) {
        return "".concat(result, " ").concat(this.props.unit);
      } else {
        return result;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          formatter = _this$props.formatter,
          label = _this$props.label,
          disabled = _this$props.disabled,
          disabledText = _this$props.disabledText;
      var _this$state2 = this.state,
          min = _this$state2.min,
          max = _this$state2.max;
      var disabledWithText = disabled && disabledText;
      return /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
        width: "100%",
        flexDirection: "column"
      }, /*#__PURE__*/_react.default.createElement(Header, {
        mt: "-6px"
      }, disabledWithText ? /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
        size: "2",
        mt: 0.3,
        color: "black60"
      }, disabledText) : /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
        justifyContent: "space-between"
      }, /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
        size: "2",
        color: "black100",
        mt: 0.3
      }, label), /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
        size: "2",
        color: "black60",
        mt: 0.3
      }, formatter ? formatter(min, max, this.maxIndicator()) : this.toString()))), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
        flexDirection: "column",
        alignItems: "left",
        mt: -1,
        mb: 1
      }, /*#__PURE__*/_react.default.createElement(SliderContainer, null, /*#__PURE__*/_react.default.createElement(_Slider.Slider, _extends({
        disabled: this.props.disabled,
        my: 1,
        mx: 1
      }, this.props, {
        onChange: function onChange(minMax) {
          _this2.updateMinMax(minMax);
        }
      })))));
    }
  }]);

  return LabeledRange;
}(_react.default.Component);

exports.LabeledRange = LabeledRange;

_defineProperty(LabeledRange, "defaultProps", {
  disabled: false
});

LabeledRange.displayName = "LabeledRange";

var Header = _styledComponents.default.div.withConfig({
  displayName: "LabeledRange__Header",
  componentId: "z0k1ro-0"
})(["cursor:pointer;padding-bottom:16px;user-select:none;", ";"], _styledSystem.space);

var SliderContainer = _styledComponents.default.div.withConfig({
  displayName: "LabeledRange__SliderContainer",
  componentId: "z0k1ro-1"
})(["width:100%;"]);

Header.displayName = "Header";
//# sourceMappingURL=LabeledRange.js.map